import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AlertApi,
  AnyApiFactory,
  ConfigApi,
  alertApiRef,
  configApiRef,
  createApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';

type ToastStatus = 'neutral' | 'info' | 'success' | 'warning' | 'danger';
type ToastMessage = {
  title: unknown;
  description?: unknown;
  status?: ToastStatus;
  timeout?: number;
};
type ToastApi = {
  post(toast: ToastMessage): { close(): void };
};

const toastApiRef = createApiRef<ToastApi>({ id: 'core.toast' });

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }: { alertApi: AlertApi }) => ({
      post: (toast: ToastMessage) => {
        const statusToSeverity = {
          neutral: 'info',
          info: 'info',
          success: 'success',
          warning: 'warning',
          danger: 'error',
        } as const;

        let text = 'Notification';
        if (typeof toast.title === 'string') {
          text = toast.title;
        } else if (typeof toast.description === 'string') {
          text = toast.description;
        }

        alertApi.post({
          message: text,
          severity: statusToSeverity[toast.status ?? 'success'],
          // Use a transient alert when timeout is provided, matching toast semantics.
          display: toast.timeout === undefined ? 'permanent' : 'transient',
        });

        return {
          close: () => {
            // AlertApi does not support programmatic close; this is a no-op fallback.
          },
        };
      },
    }),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }: { configApi: ConfigApi }) =>
      ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
